export const navData = [
  { title: "spaces", href: "#" },
  { title: "prototypes", href: "#" },
  { title: "boards", href: "#" },
  { title: "favorites", href: "#" },
]
